<template>
    <RowColumn type="none" class="bg-white rounded-shadow m-1">
        <div class="container pt-3">
            <div class="flex justify-between pt-2 items-center">
                <ButtonTag :is-tw-main-btn="true" :is-w100="false">
                    <router-link
                        class="pt-1 text-white text-decoration-none"
                        :to="$i18nHelper.getUrl('production/finishedProducts/add')"
                    >
                        {{ $t('add') }}
                    </router-link>
                </ButtonTag>
                <SearchCollapse :is-bg-white="false"></SearchCollapse>
            </div>
        </div>
        <div class="pt-5">
            <table class="w-full bg-white">
                <thead>
                <tr>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">#</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden sm:table-cell">
                        {{ $t('image.title') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('name') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden md:table-cell">
                        {{ $t('category') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('unitOfMeasure.short') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden md:table-cell">
                        {{ $t('price') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('warehouse.title') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(product, index) in products" :key="index">
                    <td class="py-2 px-4">{{ index + 1 }}</td>
                    <td class="py-2 px-4 hidden sm:table-cell">
                        <img :src="product.img" class="h-10 w-10 rounded-full">
                    </td>
                    <td class="py-2 px-4">{{ product.name }}</td>
                    <td class="py-2 px-4 hidden md:table-cell">{{ product.category }}</td>
                    <td class="py-2 px-4 text-redForLoss">{{ product.unitOfMeasure }}</td>
                    <td class="px-1 mx-1 text-left-5 hidden md:table-cell">{{ product.price }}UZS</td>
                    <td class="py-2 px-4 text-redForLoss">{{ product.warehouse }}</td>
                    <td class="py-2 px-4">
                        <div class="actions-cell">
                            <img
                                src="/images/Pencil.svg"
                                alt="Tahrir"
                                class="h-7 cursor-pointer"
                                @click="editProduct(index)"
                            >
                            <img
                                src="/images/Remove.svg"
                                alt="O'chirish"
                                class="h-6 cursor-pointer"
                                @click="showRemoveModal(index)"
                            >
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <!-- Remove Modal -->
            <b-modal
                hide-footer
                id="remove-product-modal"
                v-model="isRemoveModalVisible"
                :title="$t('deleteConfirmSimple')"
            >
                <div class="text-center">
                    <div class="mt-4 gap-4">
                        <b-button variant="danger mr-4" @click="removeProduct">{{ $t("delete") }}</b-button>
                        <b-button variant="secondary" @click="closeRemoveModal">{{ $t("cancel") }}</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
    </RowColumn>
</template>

<script>

import RowColumn from "@/components/RowColumn.vue";
import SearchCollapse from "@/components/SearchCollapse.vue";
import ButtonTag from "@/components/html/ButtonTag.vue";
import {mapActions} from "vuex";

export default {
    components: {ButtonTag, SearchCollapse, RowColumn},
    data() {
        return {
            isRemoveModalVisible: false,
            selectedIndex: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'Tayyor mahsulot'},

            ],
            products: [
                {
                    img: '/images/mayonez.jpg',
                    name: 'Gamburger mini',
                    category: 'Burgerlar',
                    unitOfMeasure: 'dona gr',
                    price: '25 000',
                    warehouse: 'yeguliklar',
                },
                {
                    img: '/images/mayonez.jpg',
                    name: 'Gamburger mini',
                    category: 'Burgerlar',
                    unitOfMeasure: 'dona gr',
                    price: '25 000',
                    warehouse: 'yeguliklar',
                },
            ],
        }
    },
    methods: {
        ...mapActions(['setBreadcrumbItems']),
        showRemoveModal(index) {
            this.selectedIndex = index
            this.isRemoveModalVisible = true
        },
        removeProduct() {
            if (this.selectedIndex !== null) {
                this.products.splice(this.selectedIndex, 1)
                this.closeRemoveModal()
            }
        },
        closeRemoveModal() {
            this.isRemoveModalVisible = false
            this.selectedIndex = null
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
}
</script>

<style>
.actions-cell {
    display: flex;
    align-items: center;
}

.actions-cell button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

tbody tr {
    border-bottom: 1px solid #e0e0e0;
}
</style>
